<template lang="html">
<div id="header">
  <h1>Studenterbaren</h1>
  <h2>-en del af Studenterhus AARHUS</h2>
</div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>

#header{
  background-color: var(--primaryColor);
  color: var(--secondaryColor);
  padding: 10px;
  box-shadow: 0 4px 4px rgba(0,0,0,0.3);
  position: fixed;

  width: 100%;
  z-index: 10;
}

h1::before{
  background-image: url('../assets/lines.png');
  background-size: cover;
  display: inline-block;
  width: 20px;
  height: 1em;
  content:"";
}
h1, h2{
  text-align: left;
  margin: 0;
  font-size: 1.2em;
}
h2{
  font-size: 0.9em;
  margin-left: 0.5em;
}

</style>
